var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrap"},[_c('XHeader'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('client-only',[(_vm.$store.state.app.showLoginPop)?_c('LoginPop'):_vm._e()],1),_vm._v(" "),_c('XFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }